// extracted by mini-css-extract-plugin
export var numpadContainer = "_ob-1";
export var phoneButton = "_ob-0";